import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const ModalFinalizaCessao = ({ open, onClose, irParaTelaHistoricoCessao, textoConfirmacao = '' }) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (reason === 'escapeKeyDown') return;
    onClose();
  };

  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose} fullWidth className="dialog-conta">
      <DialogTitle className="titulo-modal">Cessão finalizada com sucesso!</DialogTitle>
      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          {textoConfirmacao}
        </Typography>
      </DialogContent>
      <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
        <Button
          variant="contained"
          onClick={() => irParaTelaHistoricoCessao()}
          className="dialog-conta__btn-escolher"
        >
          Ir para Gestão da cessão
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalFinalizaCessao;
